const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export {
  // eslint-disable-next-line import/prefer-default-export
  capitalizeFirstLetter
};
